export enum UserStatus {
  WaitingForRegistration = 'waiting_for_registration',
  WaitingForApproval = 'waiting_for_approval',
  DemoAccount = 'demo_account',
  Deactivated = 'deactivated',
  Active = 'active',
}
